module.exports = __webpack_public_path__ + "img/retired-2012-huludao.4c9702a1.jpg";